import { Box } from '@mui/material';
import React from 'react';
import { RHFTextField } from 'src/components/hook-form';
import { translateKey } from 'src/locales/translate';
import { SPAN_FULL } from './medicationFormLayout';
import {
  STOCK_RECIPIENT_ADDRESS_MAX,
  STOCK_RECIPIENT_MAX,
} from './medicationStockValues';
import { useRecipientAddressPrefill } from './useRecipientAddressPrefill';

interface MedicationStockRecipientFieldsProps {
  locked: boolean;
  /** An Rx drug handed over is a retail supply: its record needs the address (#688 R1-2). */
  isRx: boolean;
  /** A new taking may start with the owner's address already on screen. */
  prefill: boolean;
  ownerAddress?: string;
}

/** "Odbiorca" of a handed-over drug and, for an Rx drug, "Adres odbiorcy". */
export default function MedicationStockRecipientFields({
  locked,
  isRx,
  prefill,
  ownerAddress,
}: MedicationStockRecipientFieldsProps): React.ReactElement {
  useRecipientAddressPrefill(isRx && prefill, ownerAddress);

  return (
    <>
      <Box sx={SPAN_FULL}>
        <RHFTextField
          name="stockRecipientName"
          label={translateKey('warehouse.clinical.recipient')}
          helperText={translateKey('warehouse.clinical.recipientHelp')}
          disabled={locked}
          inputProps={{
            maxLength: STOCK_RECIPIENT_MAX,
            'data-testid': 'medication-stock-recipient',
          }}
        />
      </Box>
      {isRx && (
        <Box sx={SPAN_FULL}>
          <RHFTextField
            name="stockRecipientAddress"
            label={translateKey('warehouse.clinical.recipientAddress')}
            helperText={translateKey('warehouse.clinical.recipientAddressHelp')}
            disabled={locked}
            // Marked, not natively required: a blank field is valid while the
            // owner received the drug (the backend reads their profile).
            InputLabelProps={{ required: true }}
            inputProps={{
              maxLength: STOCK_RECIPIENT_ADDRESS_MAX,
              'data-testid': 'medication-stock-recipient-address',
            }}
          />
        </Box>
      )}
    </>
  );
}
